import CustomModal from "../CustomModal";
import { Button } from "antd";
import Lottie from "lottie-react";
import fileUploadAnimation from "../../assets/animations/download-animation.json";
import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";

const UploadProgressModal = ({
  visible,
  onCancel,
  progress,
  downloadedSize,
  totalSize,
}) => {
  const { t } = useTranslation();
  const lottieRef = useRef();

  // Control only filling frames (51–142)
  useEffect(() => {
    if (
      lottieRef.current &&
      fileUploadAnimation &&
      typeof progress === "number"
    ) {
      const fillStart = 51;
      const fillEnd = 142;
      const frame = fillStart + (progress / 100) * (fillEnd - fillStart);
      lottieRef.current.goToAndStop(frame, true);
    }
  }, [progress]);

  // Only allow closing when download is complete
  const handleCancel = () => {
    if (progress >= 100) {
      onCancel(); // allow closing only after download complete
    }
  };

  return (
    <CustomModal
      title=""
      visible={visible}
      handleCancel={handleCancel}
      cancelBtnText={t("common.cancel")}
      width={400}
      className="my-custom-modal"
      footer={false}
      closable={progress >= 100} // 🔒 Hide close icon if not done
      maskClosable={false} // prevent click-outside close
    >
      <div className="upload-progress-content">
        <div
          className="dialog-header"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <div style={{ width: 150, height: 150 }}>
            <Lottie
              lottieRef={lottieRef}
              animationData={fileUploadAnimation}
              loop={false}
              autoplay={false}
            />
          </div>
        </div>

        <div className="dialog-text" style={{ textAlign: "center" }}>
          <h2 className="dialog-title">{t("common.downloading")}...</h2>
          <p className="dialog-message">
            {downloadedSize} / {totalSize} ({progress}%)
          </p>
        </div>
      </div>

      <div className="custom-modal-footer">
        <Button
          type="primary"
          onClick={handleCancel}
          className="continue-btn primary-btn"
          disabled={progress < 100}
        >
          {t("common.done")}
        </Button>
      </div>
    </CustomModal>
  );
};

export default UploadProgressModal;
